module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/a1a1c4e16826a2d41439a1c9a74a599c.png";